export enum QueryParam {
  CardTransactionReference = 'cardTransactionReference',
  BanklinkTransactionReference = 'banklinkTransactionReference',
  Status = 'status',
  Brand = 'brand',
}
